// https://vuex.vuejs.org/en/state.html

let state = {
  curLanguage: localStorage.getItem('language') || 'en',
  errorMsg: ''

}

export default state
